import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

export var environment: any;
@Injectable({
    providedIn: 'root'
})
export class ConfigService {

    constructor(private httpClient: HttpClient) {
        console.log("Config Service Called");
        
    }

    setConfig() {
        return this.httpClient.get('/assets/app-config.json')
            .toPromise()
            .then(data => {
                environment = data;
                console.log("data",data)
            })
    }

    

}
